import {
  Flex,
  spacing,
  useColorMode,
  useIsDesktopView,
  useIsMobileView,
} from 'deepstash-ui';
import useSource from 'providers/hooks/useSource';
import React from 'react';
import CuratorsNote from 'src/components/cards/CuratorsNote';
import SubsectionHeader from 'src/components/metacontent/components/SubsectionHeader';
import CuratorSection from 'src/components/metacontent/sections/CuratorSection';
import { GAP_SIZE_REM, getRemWidthFromColumns, getTintHex } from 'utils/global';
import commonStrings from 'utils/strings/commonStrings';
import SourceTitleByType from './header/SourceTitleByType';
import SourceCardVerticalProgress from './SourceCardVerticalProgress';

const IdeaPageMetacontent: React.FC = () => {
  const isDesktopView = useIsDesktopView();
  const { colorMode } = useColorMode();
  const isMobileView = useIsMobileView();

  const { source } = useSource();

  if (!source) return null;

  const curatorData = (
    <Flex
      w={{ base: '100%', md: getRemWidthFromColumns(4) }}
      flexDirection="column"
    >
      {!isMobileView && (
        <>
          <SubsectionHeader mb={spacing.XXS.rem}>
            {commonStrings.metacontent.curatedFrom}
          </SubsectionHeader>
          <SourceTitleByType
            source={source}
            size={'md'}
            withLink={true}
            m={0}
            numberOfLines={5}
          />
        </>
      )}
      <CuratorSection mt={GAP_SIZE_REM} user={source.userData} />
      {source.context && (
        <CuratorsNote
          text={source.context}
          quoteColor={getTintHex({
            ogColor: source.imageColor,
            opacity: 0.5,
            colorScheme: colorMode,
          })}
        />
      )}
    </Flex>
  );

  return isDesktopView ? (
    <Flex w={getRemWidthFromColumns(11)} justifyContent="space-between">
      <SourceCardVerticalProgress source={source} />
      {curatorData}
    </Flex>
  ) : (
    curatorData
  );
};

export default IdeaPageMetacontent;
